export default __webpack_public_path__ + "static/media/cdl.ff0f5765.jpg";